import React, { useEffect, useRef } from 'react';
import s from './index.module.scss';
import GrtPlayer from 'grt-player';

const { initPlayer: XGPlayer } = GrtPlayer;

/**
 * 视频播放器组件
 * 使用统一的 xgplayer 封装，支持 m3u8/HLS 播放
 */
const VideoPlayer = ({
    videoUrl,
    poster,
    title,
    autoPlay = false,
    controls = true,
    width = '100%',
    height = 'auto',
    onReady,
    onEnded
}) => {
    const containerRef = useRef(null);
    const playerRef = useRef(null);

    useEffect(() => {
        if (!videoUrl || !containerRef.current) {
            return;
        }

        // 销毁旧实例
        if (playerRef.current && playerRef.current.destroy) {
            playerRef.current.destroy();
            playerRef.current = null;
        }

        playerRef.current = XGPlayer({
            el: containerRef.current,
            url: videoUrl,
            poster,
            autoplay: autoPlay,
            controls,
            fluid: false,
            videoInit: true,
            // 只关闭浏览器原生全屏（fullscreen 插件），保留大屏 / 剧场模式（cssFullscreen）
            ignores: ['danmu', 'fullscreen'],
            cssFullscreen: true,
            width: '100%',
            height: '100%',
            playbackRate: [0.75, 1, 1.25, 1.5, 2],
            playsinline: true,
            lang: 'zh-cn'
        });

        if (typeof onReady === 'function') {
            onReady(playerRef.current);
        }

        // 监听播放结束
        if (playerRef.current && typeof onEnded === 'function') {
            playerRef.current.on('ended', onEnded);
        }

        return () => {
            if (playerRef.current && playerRef.current.destroy) {
                playerRef.current.destroy();
                playerRef.current = null;
            }
        };
    }, [videoUrl, autoPlay, controls, poster, onReady, onEnded]);

    return (
        <div className={s['video-player']} style={{ width, height }}>
            {title && <div className={s['video-title']}>{title}</div>}
            <div className={s['player-wrapper']} ref={containerRef}></div>
        </div>
    );
};

export default VideoPlayer;

